import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconArrowDropDownLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.291 13.924 8.14 10.773a.512.512 0 0 1-.103-.146.458.458 0 0 1 .087-.492.423.423 0 0 1 .328-.135h6.638a.42.42 0 0 1 .328.137.46.46 0 0 1 .124.32c0 .03-.047.135-.14.316l-3.151 3.151a.637.637 0 0 1-.48.209.637.637 0 0 1-.48-.209Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconArrowDropDownLine;
